export enum ChargeType {
  TAX,
  SERVICE
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/charge.type.model.ts